// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/HUD/player_info_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@assets/HUD/final_chest_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@assets/HUD/player_profile_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@assets/HUD/team_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@assets/HUD/spectator_progress_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("@assets/HUD/progress_fill.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("@assets/HUD/player_lv_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("@assets/HUD/light_glow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("@assets/HUD/reward_footer_ornament.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("@assets/HUD/confirm_btn_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("@assets/HUD/button_bg_idle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("@assets/HUD/button_bg_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("@assets/HUD/small_box_btn_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("@assets/HUD/small_box_btn_bg_active.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

.flex {
  display: flex;
}

.grid {
  display: grid;
}

.flex_wrap {
  flex-wrap: wrap;
}

.flex-1 {
  flex: 1;
}

.flex_col {
  flex-direction: column;
}

.flex_row_reverse {
  flex-direction: row-reverse !important;
}

.width_full {
  width: 100%;
}

.width_half {
  width: 50%;
}

.max_w_lg {
  max-width: 1240px;
  margin: 0 auto;
}

.gamehud {
  position: relative;
  width: 100%;
  height: 100%;
}

.hud-container {
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 2;
  padding: 10px;
}

.justify_center {
  justify-content: center;
}

.justify_between {
  justify-content: space-between;
}

.justify_end {
  justify-content: flex-end;
}

.justify_start {
  justify-content: flex-start;
}

.row_reverse {
  flex-direction: row-reverse;
}

.items_center {
  align-items: center;
}

.gap_4 {
  gap: 4px;
}

.gap_16 {
  gap: 16px;
}

.gap_24 {
  gap: 24px;
}

.padding_4 {
  padding: 4px;
}

.padding_8 {
  padding: 8px;
}

.padding_top_8 {
  padding-top: 8px;
}

.padding_top_16 {
  padding-top: 16px;
}

.padding_right_16 {
  padding-right: 16px;
}

.padding_y_4 {
  padding: 4px 0;
}

.relative {
  position: relative;
}

.item {
  width: 43px;
  height: 43px;
  border: 1px solid #3e5367;
  border-radius: 6px;
  background-color: #1c1f25;
  display: flex;
  align-items: center;
  justify-content: center;
}

.item:hover {
  border-color: #71deff;
}

.player_info_container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
  width: 22vw;
  height: 104px;
  display: flex;
  align-items: center;
  gap: 4px;
  position: relative;
  padding: 8px 16px 12px 36px;
  max-width: 320px;
  min-width: 260px;
  font-family: 'Kim';
}

.player_info_container_right {
  flex-direction: row-reverse;
  margin-right: 20px;
}

.player_info_container_right .player_info_team {
  transform: scaleX(-1);
  margin-right: -4px;
}

.player_info_container_right .player_info_team span {
  display: inline-block;
  transform: scaleX(-1);
}

.player_info_lv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 100% 100%;
  width: 56px;
  height: 56px;
  position: absolute;
  top: 22px;
  left: -2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: 'Kim';
}

.player_info_lv_right {
  left: auto;
  right: -20px;
}

.player_info_lv span {
  font-size: 10px;
  color: #ffa600;
}

.player_info_lv .player_info_lvalue {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
}

.player_info_player_profile {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 100% 100%;
  width: 72px;
  height: 72px;
  border: 1px solid #274c57;
}

.player_info_player_profile>img {
  width: 100%;
  height: 100%;
}

.player_info {
  display: flex;
  flex-direction: column;
  position: relative;
  width: calc(100% - 72px);
}

.player_info_name {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  padding: 3px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 100% 100%;
}

.player_info_rank {
  display: flex;
  align-items: center;
  gap: 4px;
}

.player_info_rank img {
  width: 46px;
  height: 36px;
}

.player_info_rank span {
  font-size: 24px;
  color: white;
  margin-top: -2px;
  margin-right: 4px;
  font-style: italic;
  font-family: 'Kim';
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.player_info_team {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 100% 100%;
  padding: 2px;
  /* padding-left: 10px; */
  font-size: 10px;
  color: #ffffff;
  /* margin-left: -4px;  */

  width: 100%;
  height: 14px;
  position: absolute;
  bottom: 0;
}

.hud_bar_container {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
}

.hud_bar_bg {
  flex: 1;
  height: 8px;
  background-color: #1c1f25;
  border-radius: 8px;
  overflow: hidden;
  padding: 1px;
}

.hud_bar_status {
  font-size: 12px;
  color: #ffffff;
  min-width: 60px;
  text-align: right;
}

.xp_bar_bg_container {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  color: #71deff;
  width: 92%;
  margin-left: 10px;
}

.xp_bar_bg_container img {
  width: 10px;
  height: 12px;
}

.xp_bar_bg {
  height: 8px;
  width: 100%;
  padding: 1px;
  flex: 1;
  background-color: #1c1f25;
  border-radius: 2px;
  overflow: hidden;
}

.cooldown_bar {
  background-color: gold;
  height: 6px;
  border-radius: 2px;
}

.player_hud_skills {
  width: 100%;
  max-width: 48px;
  height: 48px;
  flex-shrink: 0;
  background-color: #1c1f25;
  border: 1px solid #274c57;
  border-radius: 4px;
  cursor: var(--game-pointer);
}

.goldend_background {
  background-color: goldenrod;
}

.spectator_container {
  position: absolute;
  top: 8px;
  right: 0.5vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  z-index: 10;
}

.spectator_container_right {
  position: absolute;
  top: 8px;
  left: 1.75vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  z-index: 10;
}

.spectator_container div img {
  width: 100%;
  height: 100%;
}

.spectator_container_right div img {
  width: 100%;
  height: 100%;
}

.spectator_progress {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: 100% 100%;
  width: 36%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  position: relative;
}

.spectator_progress_bar_bg {
  background-color: #1c1f25;
  width: 100%;
  height: 100%;
}

.spectator_progress_fill {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  transition: width 0.3s ease-in-out;
  display: flex;
  flex-direction: row-reverse;
}

.spectator_progress_fill_mask {
  height: 100%;
  /* width: 50%;  */
  background-color: #1c1f25;
}

.progress_ches_mark {
  width: 48px;
  height: 48px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: 100% 100%;
  padding: 14px;
  position: absolute;
  right: -20px;
}

.progress_ches_mark img {
  width: 100%;
  height: 100%;
}

.progress_chest_bronze {
  position: absolute;
  left: 64.4%;
  top: -21px;
}

.progress_chest_silver {
  position: absolute;
  left: 31.8%;
  top: -21px;
}

.progress_chest_bronze img {
  width: 24px;
  height: 22px;
}

.progress_chest_silver img {
  width: 24px;
  height: 22px;
}






.light_streak_container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(28, 31, 37, 0.95);
}

.light_streak_chest {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: 100% 100%;
  position: absolute;
  width: 800px;
  height: 800px;

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
}

.light_streak_chest img {
  width: 200px;
  transition: width 0.3s ease-out;
  cursor: pointer;
}

.light_streak_chest img:hover {
  width: 210px;
  transform: scale(1.05);
}

.streak_gold_list_container {
  display: flex;
  gap: 8px;
  position: absolute;
  bottom: 248px;
  z-index: 20;
}

.streak_gold_list {
  width: 68px;
  height: 68px;
  background-color: #1c1f25;
  border: 1px solid #147fa6;
  border-radius: 4px;

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  z-index: 10;
  position: relative;
}

.streak_gold_list img {
  width: 64px;
  height: 58px;
  margin-left: 6px;
}

.streak_gold_list>div:first-child {
  width: 32px;
  height: 32px;
  background-repeat: no-repeat;
}

.streak_gold_list_amount {
  position: absolute;
  bottom: 6px;
  right: 12px;
  font-size: 12px;
  font-weight: bold;
  color: white;
}

.light_streak {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
}

.streak_cofirm_container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-size: 100% 100%;
  width: 100%;
  height: 64px;

  display: flex;
  justify-content: center;

  position: absolute;
  bottom: 164px;
  z-index: 30;
}

.streak_confirm_btn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-size: 100% 100%;
  width: 168px;
  height: 64px;

  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  text-transform: uppercase;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
}

.game_setting {
  background-color: #252b36;
  border: 1px solid #4583d0;
  border-radius: 4px;
  padding: 6px 8px;
  margin-bottom: 4px;
  text-align: center;
  cursor: var(--game-pointer);
  font-family: 'Kim';
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}


.exit_game_label {
  background-color: #252b36;
  border: 1px solid #4583d0;
  border-radius: 4px;
  padding: 6px 8px;
  margin-bottom: 4px;
  text-align: center;
  cursor: var(--game-pointer);
  font-family: 'Kim';
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.exit_game_menu {
  cursor: var(--game-pointer);
  font-family: 'Kim';
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.setting_menu {
  background-color: #252b36;
  padding: 16px;
  border: 2px solid #51fdff;
  border-radius: 8px;
  font-family: 'Kim';
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.setting_menu_btn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-size: 100% 100%;
  width: 50%;
  height: 52px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #ffffff;

  cursor: pointer;
}

.setting_menu_btn:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.setting_menu_btn_inactive {
  opacity: 0.5;
}

.setting_menu_btn_active {
  color: #51fdff;
  opacity: 1.0;
}

.setting_dialog {
  /* background-image: url("@assets/leaderboard/recap_bg.png"); */
  background-size: 100% 100%;
  width: 400px;
  /* height: 140px; */
  padding: 15px;
  /* display: flex; 
  text-align: center;
  justify-content: center;
  align-items: center;  */
  color: #ffffff;
}

.setting_dialog_keyboard {
  margin-bottom: 12px;
}

.setting_dialog_control_bar_container {
  display: flex;
  align-items: center;
}

.setting_dialog_control_name {
  width: 30%;
}

.setting_dialog_control_bar {
  display: flex;
  align-items: center;
  width: 60%;
  height: 50px;
  /* background-color: #f1f1f1; */
  /* border: 1px solid #ccc; */
  padding: 0 6px;
}

.setting_dialog_control_line {
  flex-grow: 1;
  height: 2px;
  background-color: #4583d0;
  position: relative;
  margin: 0 0;
}

.setting_dialog_control_thumb {
  width: 10px;
  height: 20px;
  background-color: #252b36;
  border: 2px solid #4583d0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;

}

.setting_dialog_control_label_start {
  width: 2.5%;
}

.setting_dialog_control_label_end {
  width: 7.5%;
}

.light_shining_bg {
  position: absolute;
  width: 800px;
}

.light_shining_bg img {
  width: 100%;
  animation: rotate 20s linear infinite;
}

.spell_target .equip-dialog-image {
  width: 34px;
  height: 36px;
}

.spell_target .dialog-spell-info {
  gap: 2px;
}

.spectator_div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.spectator {
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-size: 100% 100%;
  padding: 4px;
  cursor: var(--game-pointer);
}

.spectator:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

.flip {
  transform: scale(0.6) scaleX(-1);
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes oscillate-brightness {

  0%,
  100% {
    filter: brightness(1);
  }

  50% {
    filter: brightness(1.5);
  }
}

.blinking-gradient {
  background: linear-gradient(to bottom right, #ecbb29, #1c1f25);
  animation: oscillate-brightness 0.5s ease-in-out infinite;
}

.glitch {
  /* font-size: 5rem; */
  font-weight: bold;
  text-transform: uppercase;
  position: relative;
  text-shadow: 0.05em 0 0 #00fffc, -0.03em -0.04em 0 #fc00ff,
    0.025em 0.04em 0 #fffc00;
  animation: glitch 725ms infinite;
}

.glitch span {
  position: absolute;
  top: 0;
  left: 0;
}

.glitch span:first-child {
  animation: glitch 500ms infinite;
  clip-path: polygon(0 0, 100% 0, 100% 35%, 0 35%);
  transform: translate(-0.04em, -0.03em);
  opacity: 0.75;
}

.glitch span:last-child {
  animation: glitch 375ms infinite;
  clip-path: polygon(0 65%, 100% 65%, 100% 100%, 0 100%);
  transform: translate(0.04em, 0.03em);
  opacity: 0.75;
}

@keyframes glitch {
  0% {
    text-shadow: 0.05em 0 0 #00fffc, -0.03em -0.04em 0 #fc00ff,
      0.025em 0.04em 0 #fffc00;
  }

  15% {
    text-shadow: 0.05em 0 0 #00fffc, -0.03em -0.04em 0 #fc00ff,
      0.025em 0.04em 0 #fffc00;
  }

  16% {
    text-shadow: -0.05em -0.025em 0 #00fffc, 0.025em 0.035em 0 #fc00ff,
      -0.05em -0.05em 0 #fffc00;
  }

  49% {
    text-shadow: -0.05em -0.025em 0 #00fffc, 0.025em 0.035em 0 #fc00ff,
      -0.05em -0.05em 0 #fffc00;
  }

  50% {
    text-shadow: 0.05em 0.035em 0 #00fffc, 0.03em 0 0 #fc00ff,
      0 -0.04em 0 #fffc00;
  }

  99% {
    text-shadow: 0.05em 0.035em 0 #00fffc, 0.03em 0 0 #fc00ff,
      0 -0.04em 0 #fffc00;
  }

  100% {
    text-shadow: -0.05em 0 0 #00fffc, -0.025em -0.04em 0 #fc00ff,
      -0.04em -0.025em 0 #fffc00;
  }
}

.height_full {
  height: 100vh;
}

.padding_bottom_16 {
  padding-bottom: 16px;
}

.enemy_turn_banner {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  
  /* Container styling */
  background: linear-gradient(
    90deg,
    rgba(28, 31, 37, 0) 0%,
    rgba(202, 48, 77, 0.3) 20%,
    rgba(202, 48, 77, 0.4) 50%,
    rgba(202, 48, 77, 0.3) 80%,
    rgba(28, 31, 37, 0) 100%
  );
  padding: 12px 40px;
  border-radius: 4px;
  
  /* Text styling */
  font-family: 'Kim', sans-serif;
  font-size: 24px;
  color: #ffffff;
  text-align: center;
  text-transform: uppercase;
  text-shadow: 
    0 0 10px rgba(202, 48, 77, 0.8),
    -1px -1px 0 #ca304d,
    1px -1px 0 #ca304d,
    -1px 1px 0 #ca304d,
    1px 1px 0 #ca304d;
  
  /* Animation */
  animation: enemyTurnBanner 0.5s ease-out forwards,
             enemyTurnPulse 2s infinite;
}

@keyframes enemyTurnBanner {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

@keyframes enemyTurnPulse {
  0%, 100% {
    box-shadow: 
      0 0 20px rgba(202, 48, 77, 0.3),
      inset 0 0 20px rgba(202, 48, 77, 0.3);
  }
  50% {
    box-shadow: 
      0 0 30px rgba(202, 48, 77, 0.5),
      inset 0 0 30px rgba(202, 48, 77, 0.5);
  }
}

/* Add a decorative element before and after the text */
.enemy_turn_banner::before,
.enemy_turn_banner::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 20px;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent,
    #ca304d,
    transparent
  );
}

.enemy_turn_banner::before {
  left: 10px;
  transform: translateY(-50%);
}

.enemy_turn_banner::after {
  right: 10px;
  transform: translateY(-50%);
}

.player_turn_banner_container {
  position: fixed;
  top: 19vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 12px;

  @media screen and (max-height: 600px) {
    top: 21vh;
  }

  @media screen and (max-height: 400px) {
    top: 12vh;
  }
}

.player_turn_banner {
  position: relative;
  background: linear-gradient(
    90deg,
    rgba(28, 31, 37, 0) 0%,
    rgba(69, 131, 208, 0.3) 20%,
    rgba(69, 131, 208, 0.4) 50%,
    rgba(69, 131, 208, 0.3) 80%,
    rgba(28, 31, 37, 0) 100%
  );
  padding: clamp(6px, 1vh, 8px) clamp(20px, 3vw, 30px);
  border-radius: 4px;
  min-width: clamp(160px, 20vw, 200px);
  
  font-family: 'Kim', sans-serif;
  font-size: clamp(14px, 2vw, 18px);
  color: #ffffff;
  text-align: center;
  text-transform: uppercase;
  text-shadow: 
    0 0 8px rgba(69, 131, 208, 0.8),
    -1px -1px 0 #4583d0,
    1px -1px 0 #4583d0,
    -1px 1px 0 #4583d0,
    1px 1px 0 #4583d0;

  @media screen and (max-height: 600px) {
    padding: 4px 20px;
    font-size: clamp(12px, 1.8vw, 16px);
  }

  @media screen and (max-height: 400px) {
    padding: 3px 15px;
    font-size: clamp(10px, 1.5vw, 14px);
  }
}

.circular_timer {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.circular_timer_bg {
  stroke: rgba(69, 131, 208, 0.2);
}

.circular_timer_progress {
  stroke: #4583d0;
  transition: stroke-dashoffset 0.1s linear;
  transform-origin: center;
  stroke-linecap: round;
  transform: rotate(-90deg);
  transform-origin: center;
}

.circular_timer_icon {
  position: absolute;
  width: 60%;
  height: 60%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.target_selection_banner {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  
  /* Container styling */
  background: linear-gradient(
    90deg,
    rgba(28, 31, 37, 0) 0%,
    rgba(45, 212, 191, 0.3) 20%,
    rgba(45, 212, 191, 0.4) 50%,
    rgba(45, 212, 191, 0.3) 80%,
    rgba(28, 31, 37, 0) 100%
  );
  padding: 8px 30px;
  border-radius: 4px;
  
  /* Text styling */
  font-family: 'Kim', sans-serif;
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  text-transform: uppercase;
  text-shadow: 
    0 0 10px rgba(45, 212, 191, 0.8),
    -1px -1px 0 #2DD4BF,
    1px -1px 0 #2DD4BF,
    -1px 1px 0 #2DD4BF,
    1px 1px 0 #2DD4BF;
  
  /* Animation */
  animation: targetSelectionPulse 2s infinite;
}

@keyframes targetSelectionPulse {
  0%, 100% {
    box-shadow: 
      0 0 20px rgba(45, 212, 191, 0.3),
      inset 0 0 20px rgba(45, 212, 191, 0.3);
  }
  50% {
    box-shadow: 
      0 0 30px rgba(45, 212, 191, 0.5),
      inset 0 0 30px rgba(45, 212, 191, 0.5);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/HUD/HUD.style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yDAAuD;EACvD,0BAA0B;EAC1B,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,yDAAuD;EACvD,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yDAA0D;EAC1D,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,yDAAgD;EAChD,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA;EACE,yDAAgD;EAChD,0BAA0B;EAC1B,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,wBAAwB;;EAExB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,OAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yDAA8D;EAC9D,0BAA0B;EAC1B,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yDAAsD;EACtD,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yDAAqD;EACrD,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;;;;;AAOA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,yDAAmD;EACnD,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,aAAa;;EAEb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;;EAElB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;;EAEf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yDAA+D;EAC/D,0BAA0B;EAC1B,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,uBAAuB;;EAEvB,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,yDAAuD;EACvD,0BAA0B;EAC1B,YAAY;EACZ,YAAY;;EAEZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;;EAEzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,iEAAiE;AACnE;;;AAGA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA;EACE,0DAAuD;EACvD,0BAA0B;EAC1B,UAAU;EACV,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,cAAc;;EAEd,eAAe;AACjB;;AAEA;EACE,0DAAyD;AAC3D;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,+DAA+D;EAC/D,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb;;;yBAGuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,eAAe;;AAEjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0DAAyD;EACzD,0BAA0B;EAC1B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,0DAAgE;AAClE;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE;;IAEE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,8DAA8D;EAC9D,yDAAyD;AAC3D;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB;4BAC0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,gCAAgC;EAChC,gDAAgD;EAChD,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,sDAAsD;EACtD,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE;IACE;8BAC0B;EAC5B;;EAEA;IACE;8BAC0B;EAC5B;;EAEA;IACE;+BAC2B;EAC7B;;EAEA;IACE;+BAC2B;EAC7B;;EAEA;IACE;yBACqB;EACvB;;EAEA;IACE;yBACqB;EACvB;;EAEA;IACE;gCAC4B;EAC9B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,WAAW;;EAEX,sBAAsB;EACtB;;;;;;;GAOC;EACD,kBAAkB;EAClB,kBAAkB;;EAElB,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB;;;;;qBAKmB;;EAEnB,cAAc;EACd;uCACqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE;;2CAEuC;EACzC;EACA;IACE;;2CAEuC;EACzC;AACF;;AAEA,uDAAuD;AACvD;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX;;;;;GAKC;AACH;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB;;;;;;;GAOC;EACD,oDAAoD;EACpD,kBAAkB;EAClB,oCAAoC;;EAEpC,8BAA8B;EAC9B,iCAAiC;EACjC,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB;;;;;qBAKmB;;EAEnB;IACE,iBAAiB;IACjB,mCAAmC;EACrC;;EAEA;IACE,iBAAiB;IACjB,mCAAmC;EACrC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;;EAEX,sBAAsB;EACtB;;;;;;;GAOC;EACD,iBAAiB;EACjB,kBAAkB;;EAElB,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB;;;;;qBAKmB;;EAEnB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE;IACE;;4CAEwC;EAC1C;EACA;IACE;;4CAEwC;EAC1C;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\n.flex {\n  display: flex;\n}\n\n.grid {\n  display: grid;\n}\n\n.flex_wrap {\n  flex-wrap: wrap;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex_col {\n  flex-direction: column;\n}\n\n.flex_row_reverse {\n  flex-direction: row-reverse !important;\n}\n\n.width_full {\n  width: 100%;\n}\n\n.width_half {\n  width: 50%;\n}\n\n.max_w_lg {\n  max-width: 1240px;\n  margin: 0 auto;\n}\n\n.gamehud {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.hud-container {\n  display: flex;\n  justify-content: space-between;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  z-index: 2;\n  padding: 10px;\n}\n\n.justify_center {\n  justify-content: center;\n}\n\n.justify_between {\n  justify-content: space-between;\n}\n\n.justify_end {\n  justify-content: flex-end;\n}\n\n.justify_start {\n  justify-content: flex-start;\n}\n\n.row_reverse {\n  flex-direction: row-reverse;\n}\n\n.items_center {\n  align-items: center;\n}\n\n.gap_4 {\n  gap: 4px;\n}\n\n.gap_16 {\n  gap: 16px;\n}\n\n.gap_24 {\n  gap: 24px;\n}\n\n.padding_4 {\n  padding: 4px;\n}\n\n.padding_8 {\n  padding: 8px;\n}\n\n.padding_top_8 {\n  padding-top: 8px;\n}\n\n.padding_top_16 {\n  padding-top: 16px;\n}\n\n.padding_right_16 {\n  padding-right: 16px;\n}\n\n.padding_y_4 {\n  padding: 4px 0;\n}\n\n.relative {\n  position: relative;\n}\n\n.item {\n  width: 43px;\n  height: 43px;\n  border: 1px solid #3e5367;\n  border-radius: 6px;\n  background-color: #1c1f25;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.item:hover {\n  border-color: #71deff;\n}\n\n.player_info_container {\n  background-image: url(\"@assets/HUD/player_info_bg.png\");\n  background-size: 100% 100%;\n  width: 22vw;\n  height: 104px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  position: relative;\n  padding: 8px 16px 12px 36px;\n  max-width: 320px;\n  min-width: 260px;\n  font-family: 'Kim';\n}\n\n.player_info_container_right {\n  flex-direction: row-reverse;\n  margin-right: 20px;\n}\n\n.player_info_container_right .player_info_team {\n  transform: scaleX(-1);\n  margin-right: -4px;\n}\n\n.player_info_container_right .player_info_team span {\n  display: inline-block;\n  transform: scaleX(-1);\n}\n\n.player_info_lv {\n  background-image: url(\"@assets/HUD/final_chest_bg.png\");\n  background-size: 100% 100%;\n  width: 56px;\n  height: 56px;\n  position: absolute;\n  top: 22px;\n  left: -2px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-family: 'Kim';\n}\n\n.player_info_lv_right {\n  left: auto;\n  right: -20px;\n}\n\n.player_info_lv span {\n  font-size: 10px;\n  color: #ffa600;\n}\n\n.player_info_lv .player_info_lvalue {\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.player_info_player_profile {\n  background-image: url(\"@assets/HUD/player_profile_bg.png\");\n  background-size: 100% 100%;\n  width: 72px;\n  height: 72px;\n  border: 1px solid #274c57;\n}\n\n.player_info_player_profile>img {\n  width: 100%;\n  height: 100%;\n}\n\n.player_info {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: calc(100% - 72px);\n}\n\n.player_info_name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  padding: 3px;\n  background-image: url(\"@assets/HUD/team_bg.png\");\n  background-size: 100% 100%;\n}\n\n.player_info_rank {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.player_info_rank img {\n  width: 46px;\n  height: 36px;\n}\n\n.player_info_rank span {\n  font-size: 24px;\n  color: white;\n  margin-top: -2px;\n  margin-right: 4px;\n  font-style: italic;\n  font-family: 'Kim';\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.player_info_team {\n  background-image: url(\"@assets/HUD/team_bg.png\");\n  background-size: 100% 100%;\n  padding: 2px;\n  /* padding-left: 10px; */\n  font-size: 10px;\n  color: #ffffff;\n  /* margin-left: -4px;  */\n\n  width: 100%;\n  height: 14px;\n  position: absolute;\n  bottom: 0;\n}\n\n.hud_bar_container {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex: 1;\n}\n\n.hud_bar_bg {\n  flex: 1;\n  height: 8px;\n  background-color: #1c1f25;\n  border-radius: 8px;\n  overflow: hidden;\n  padding: 1px;\n}\n\n.hud_bar_status {\n  font-size: 12px;\n  color: #ffffff;\n  min-width: 60px;\n  text-align: right;\n}\n\n.xp_bar_bg_container {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 10px;\n  color: #71deff;\n  width: 92%;\n  margin-left: 10px;\n}\n\n.xp_bar_bg_container img {\n  width: 10px;\n  height: 12px;\n}\n\n.xp_bar_bg {\n  height: 8px;\n  width: 100%;\n  padding: 1px;\n  flex: 1;\n  background-color: #1c1f25;\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.cooldown_bar {\n  background-color: gold;\n  height: 6px;\n  border-radius: 2px;\n}\n\n.player_hud_skills {\n  width: 100%;\n  max-width: 48px;\n  height: 48px;\n  flex-shrink: 0;\n  background-color: #1c1f25;\n  border: 1px solid #274c57;\n  border-radius: 4px;\n  cursor: var(--game-pointer);\n}\n\n.goldend_background {\n  background-color: goldenrod;\n}\n\n.spectator_container {\n  position: absolute;\n  top: 8px;\n  right: 0.5vw;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  z-index: 10;\n}\n\n.spectator_container_right {\n  position: absolute;\n  top: 8px;\n  left: 1.75vw;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  z-index: 10;\n}\n\n.spectator_container div img {\n  width: 100%;\n  height: 100%;\n}\n\n.spectator_container_right div img {\n  width: 100%;\n  height: 100%;\n}\n\n.spectator_progress {\n  background-image: url(\"@assets/HUD/spectator_progress_bg.png\");\n  background-size: 100% 100%;\n  width: 36%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px;\n  position: relative;\n}\n\n.spectator_progress_bar_bg {\n  background-color: #1c1f25;\n  width: 100%;\n  height: 100%;\n}\n\n.spectator_progress_fill {\n  background-image: url(\"@assets/HUD/progress_fill.png\");\n  background-size: 100% 100%;\n  width: 100%;\n  height: 100%;\n  transition: width 0.3s ease-in-out;\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.spectator_progress_fill_mask {\n  height: 100%;\n  /* width: 50%;  */\n  background-color: #1c1f25;\n}\n\n.progress_ches_mark {\n  width: 48px;\n  height: 48px;\n  background-image: url(\"@assets/HUD/player_lv_bg.png\");\n  background-size: 100% 100%;\n  padding: 14px;\n  position: absolute;\n  right: -20px;\n}\n\n.progress_ches_mark img {\n  width: 100%;\n  height: 100%;\n}\n\n.progress_chest_bronze {\n  position: absolute;\n  left: 64.4%;\n  top: -21px;\n}\n\n.progress_chest_silver {\n  position: absolute;\n  left: 31.8%;\n  top: -21px;\n}\n\n.progress_chest_bronze img {\n  width: 24px;\n  height: 22px;\n}\n\n.progress_chest_silver img {\n  width: 24px;\n  height: 22px;\n}\n\n\n\n\n\n\n.light_streak_container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(28, 31, 37, 0.95);\n}\n\n.light_streak_chest {\n  background-image: url(\"@assets/HUD/light_glow.png\");\n  background-size: 100% 100%;\n  position: absolute;\n  width: 800px;\n  height: 800px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 20;\n}\n\n.light_streak_chest img {\n  width: 200px;\n  transition: width 0.3s ease-out;\n  cursor: pointer;\n}\n\n.light_streak_chest img:hover {\n  width: 210px;\n  transform: scale(1.05);\n}\n\n.streak_gold_list_container {\n  display: flex;\n  gap: 8px;\n  position: absolute;\n  bottom: 248px;\n  z-index: 20;\n}\n\n.streak_gold_list {\n  width: 68px;\n  height: 68px;\n  background-color: #1c1f25;\n  border: 1px solid #147fa6;\n  border-radius: 4px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n\n  z-index: 10;\n  position: relative;\n}\n\n.streak_gold_list img {\n  width: 64px;\n  height: 58px;\n  margin-left: 6px;\n}\n\n.streak_gold_list>div:first-child {\n  width: 32px;\n  height: 32px;\n  background-repeat: no-repeat;\n}\n\n.streak_gold_list_amount {\n  position: absolute;\n  bottom: 6px;\n  right: 12px;\n  font-size: 12px;\n  font-weight: bold;\n  color: white;\n}\n\n.light_streak {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 auto;\n}\n\n.streak_cofirm_container {\n  background-image: url(\"@assets/HUD/reward_footer_ornament.png\");\n  background-size: 100% 100%;\n  width: 100%;\n  height: 64px;\n\n  display: flex;\n  justify-content: center;\n\n  position: absolute;\n  bottom: 164px;\n  z-index: 30;\n}\n\n.streak_confirm_btn {\n  background-image: url(\"@assets/HUD/confirm_btn_bg.png\");\n  background-size: 100% 100%;\n  width: 168px;\n  height: 64px;\n\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n  text-transform: uppercase;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  cursor: pointer;\n}\n\n.game_setting {\n  background-color: #252b36;\n  border: 1px solid #4583d0;\n  border-radius: 4px;\n  padding: 6px 8px;\n  margin-bottom: 4px;\n  text-align: center;\n  cursor: var(--game-pointer);\n  font-family: 'Kim';\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n\n.exit_game_label {\n  background-color: #252b36;\n  border: 1px solid #4583d0;\n  border-radius: 4px;\n  padding: 6px 8px;\n  margin-bottom: 4px;\n  text-align: center;\n  cursor: var(--game-pointer);\n  font-family: 'Kim';\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.exit_game_menu {\n  cursor: var(--game-pointer);\n  font-family: 'Kim';\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.setting_menu {\n  background-color: #252b36;\n  padding: 16px;\n  border: 2px solid #51fdff;\n  border-radius: 8px;\n  font-family: 'Kim';\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.setting_menu_btn {\n  background-image: url(\"@assets/HUD/button_bg_idle.png\");\n  background-size: 100% 100%;\n  width: 50%;\n  height: 52px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  color: #ffffff;\n\n  cursor: pointer;\n}\n\n.setting_menu_btn:hover {\n  background-image: url(\"@assets/HUD/button_bg_active.png\");\n}\n\n.setting_menu_btn_inactive {\n  opacity: 0.5;\n}\n\n.setting_menu_btn_active {\n  color: #51fdff;\n  opacity: 1.0;\n}\n\n.setting_dialog {\n  /* background-image: url(\"@assets/leaderboard/recap_bg.png\"); */\n  background-size: 100% 100%;\n  width: 400px;\n  /* height: 140px; */\n  padding: 15px;\n  /* display: flex; \n  text-align: center;\n  justify-content: center;\n  align-items: center;  */\n  color: #ffffff;\n}\n\n.setting_dialog_keyboard {\n  margin-bottom: 12px;\n}\n\n.setting_dialog_control_bar_container {\n  display: flex;\n  align-items: center;\n}\n\n.setting_dialog_control_name {\n  width: 30%;\n}\n\n.setting_dialog_control_bar {\n  display: flex;\n  align-items: center;\n  width: 60%;\n  height: 50px;\n  /* background-color: #f1f1f1; */\n  /* border: 1px solid #ccc; */\n  padding: 0 6px;\n}\n\n.setting_dialog_control_line {\n  flex-grow: 1;\n  height: 2px;\n  background-color: #4583d0;\n  position: relative;\n  margin: 0 0;\n}\n\n.setting_dialog_control_thumb {\n  width: 10px;\n  height: 20px;\n  background-color: #252b36;\n  border: 2px solid #4583d0;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n\n}\n\n.setting_dialog_control_label_start {\n  width: 2.5%;\n}\n\n.setting_dialog_control_label_end {\n  width: 7.5%;\n}\n\n.light_shining_bg {\n  position: absolute;\n  width: 800px;\n}\n\n.light_shining_bg img {\n  width: 100%;\n  animation: rotate 20s linear infinite;\n}\n\n.spell_target .equip-dialog-image {\n  width: 34px;\n  height: 36px;\n}\n\n.spell_target .dialog-spell-info {\n  gap: 2px;\n}\n\n.spectator_div {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.spectator {\n  width: 24px;\n  height: 24px;\n  background-image: url(\"@assets/HUD/small_box_btn_bg.png\");\n  background-size: 100% 100%;\n  padding: 4px;\n  cursor: var(--game-pointer);\n}\n\n.spectator:hover {\n  background-image: url(\"@assets/HUD/small_box_btn_bg_active.png\");\n}\n\n.flip {\n  transform: scale(0.6) scaleX(-1);\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes oscillate-brightness {\n\n  0%,\n  100% {\n    filter: brightness(1);\n  }\n\n  50% {\n    filter: brightness(1.5);\n  }\n}\n\n.blinking-gradient {\n  background: linear-gradient(to bottom right, #ecbb29, #1c1f25);\n  animation: oscillate-brightness 0.5s ease-in-out infinite;\n}\n\n.glitch {\n  /* font-size: 5rem; */\n  font-weight: bold;\n  text-transform: uppercase;\n  position: relative;\n  text-shadow: 0.05em 0 0 #00fffc, -0.03em -0.04em 0 #fc00ff,\n    0.025em 0.04em 0 #fffc00;\n  animation: glitch 725ms infinite;\n}\n\n.glitch span {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.glitch span:first-child {\n  animation: glitch 500ms infinite;\n  clip-path: polygon(0 0, 100% 0, 100% 35%, 0 35%);\n  transform: translate(-0.04em, -0.03em);\n  opacity: 0.75;\n}\n\n.glitch span:last-child {\n  animation: glitch 375ms infinite;\n  clip-path: polygon(0 65%, 100% 65%, 100% 100%, 0 100%);\n  transform: translate(0.04em, 0.03em);\n  opacity: 0.75;\n}\n\n@keyframes glitch {\n  0% {\n    text-shadow: 0.05em 0 0 #00fffc, -0.03em -0.04em 0 #fc00ff,\n      0.025em 0.04em 0 #fffc00;\n  }\n\n  15% {\n    text-shadow: 0.05em 0 0 #00fffc, -0.03em -0.04em 0 #fc00ff,\n      0.025em 0.04em 0 #fffc00;\n  }\n\n  16% {\n    text-shadow: -0.05em -0.025em 0 #00fffc, 0.025em 0.035em 0 #fc00ff,\n      -0.05em -0.05em 0 #fffc00;\n  }\n\n  49% {\n    text-shadow: -0.05em -0.025em 0 #00fffc, 0.025em 0.035em 0 #fc00ff,\n      -0.05em -0.05em 0 #fffc00;\n  }\n\n  50% {\n    text-shadow: 0.05em 0.035em 0 #00fffc, 0.03em 0 0 #fc00ff,\n      0 -0.04em 0 #fffc00;\n  }\n\n  99% {\n    text-shadow: 0.05em 0.035em 0 #00fffc, 0.03em 0 0 #fc00ff,\n      0 -0.04em 0 #fffc00;\n  }\n\n  100% {\n    text-shadow: -0.05em 0 0 #00fffc, -0.025em -0.04em 0 #fc00ff,\n      -0.04em -0.025em 0 #fffc00;\n  }\n}\n\n.height_full {\n  height: 100vh;\n}\n\n.padding_bottom_16 {\n  padding-bottom: 16px;\n}\n\n.enemy_turn_banner {\n  position: fixed;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  \n  /* Container styling */\n  background: linear-gradient(\n    90deg,\n    rgba(28, 31, 37, 0) 0%,\n    rgba(202, 48, 77, 0.3) 20%,\n    rgba(202, 48, 77, 0.4) 50%,\n    rgba(202, 48, 77, 0.3) 80%,\n    rgba(28, 31, 37, 0) 100%\n  );\n  padding: 12px 40px;\n  border-radius: 4px;\n  \n  /* Text styling */\n  font-family: 'Kim', sans-serif;\n  font-size: 24px;\n  color: #ffffff;\n  text-align: center;\n  text-transform: uppercase;\n  text-shadow: \n    0 0 10px rgba(202, 48, 77, 0.8),\n    -1px -1px 0 #ca304d,\n    1px -1px 0 #ca304d,\n    -1px 1px 0 #ca304d,\n    1px 1px 0 #ca304d;\n  \n  /* Animation */\n  animation: enemyTurnBanner 0.5s ease-out forwards,\n             enemyTurnPulse 2s infinite;\n}\n\n@keyframes enemyTurnBanner {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n@keyframes enemyTurnPulse {\n  0%, 100% {\n    box-shadow: \n      0 0 20px rgba(202, 48, 77, 0.3),\n      inset 0 0 20px rgba(202, 48, 77, 0.3);\n  }\n  50% {\n    box-shadow: \n      0 0 30px rgba(202, 48, 77, 0.5),\n      inset 0 0 30px rgba(202, 48, 77, 0.5);\n  }\n}\n\n/* Add a decorative element before and after the text */\n.enemy_turn_banner::before,\n.enemy_turn_banner::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  width: 20px;\n  height: 2px;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    #ca304d,\n    transparent\n  );\n}\n\n.enemy_turn_banner::before {\n  left: 10px;\n  transform: translateY(-50%);\n}\n\n.enemy_turn_banner::after {\n  right: 10px;\n  transform: translateY(-50%);\n}\n\n.player_turn_banner_container {\n  position: fixed;\n  top: 19vh;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  @media screen and (max-height: 600px) {\n    top: 21vh;\n  }\n\n  @media screen and (max-height: 400px) {\n    top: 12vh;\n  }\n}\n\n.player_turn_banner {\n  position: relative;\n  background: linear-gradient(\n    90deg,\n    rgba(28, 31, 37, 0) 0%,\n    rgba(69, 131, 208, 0.3) 20%,\n    rgba(69, 131, 208, 0.4) 50%,\n    rgba(69, 131, 208, 0.3) 80%,\n    rgba(28, 31, 37, 0) 100%\n  );\n  padding: clamp(6px, 1vh, 8px) clamp(20px, 3vw, 30px);\n  border-radius: 4px;\n  min-width: clamp(160px, 20vw, 200px);\n  \n  font-family: 'Kim', sans-serif;\n  font-size: clamp(14px, 2vw, 18px);\n  color: #ffffff;\n  text-align: center;\n  text-transform: uppercase;\n  text-shadow: \n    0 0 8px rgba(69, 131, 208, 0.8),\n    -1px -1px 0 #4583d0,\n    1px -1px 0 #4583d0,\n    -1px 1px 0 #4583d0,\n    1px 1px 0 #4583d0;\n\n  @media screen and (max-height: 600px) {\n    padding: 4px 20px;\n    font-size: clamp(12px, 1.8vw, 16px);\n  }\n\n  @media screen and (max-height: 400px) {\n    padding: 3px 15px;\n    font-size: clamp(10px, 1.5vw, 14px);\n  }\n}\n\n.circular_timer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.circular_timer_bg {\n  stroke: rgba(69, 131, 208, 0.2);\n}\n\n.circular_timer_progress {\n  stroke: #4583d0;\n  transition: stroke-dashoffset 0.1s linear;\n  transform-origin: center;\n  stroke-linecap: round;\n  transform: rotate(-90deg);\n  transform-origin: center;\n}\n\n.circular_timer_icon {\n  position: absolute;\n  width: 60%;\n  height: 60%;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.target_selection_banner {\n  position: fixed;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  \n  /* Container styling */\n  background: linear-gradient(\n    90deg,\n    rgba(28, 31, 37, 0) 0%,\n    rgba(45, 212, 191, 0.3) 20%,\n    rgba(45, 212, 191, 0.4) 50%,\n    rgba(45, 212, 191, 0.3) 80%,\n    rgba(28, 31, 37, 0) 100%\n  );\n  padding: 8px 30px;\n  border-radius: 4px;\n  \n  /* Text styling */\n  font-family: 'Kim', sans-serif;\n  font-size: 20px;\n  color: #ffffff;\n  text-align: center;\n  text-transform: uppercase;\n  text-shadow: \n    0 0 10px rgba(45, 212, 191, 0.8),\n    -1px -1px 0 #2DD4BF,\n    1px -1px 0 #2DD4BF,\n    -1px 1px 0 #2DD4BF,\n    1px 1px 0 #2DD4BF;\n  \n  /* Animation */\n  animation: targetSelectionPulse 2s infinite;\n}\n\n@keyframes targetSelectionPulse {\n  0%, 100% {\n    box-shadow: \n      0 0 20px rgba(45, 212, 191, 0.3),\n      inset 0 0 20px rgba(45, 212, 191, 0.3);\n  }\n  50% {\n    box-shadow: \n      0 0 30px rgba(45, 212, 191, 0.5),\n      inset 0 0 30px rgba(45, 212, 191, 0.5);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
